import { jsx as _jsx } from "react/jsx-runtime";
const Aquaclean = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M12.96 8H6.02L4.31 0H3C2.45 0 2 0.45 2 1V15.53L12.24 14.99L12.5 14.68C13.26 13.71 14 10.63 14 9.39V9.07C14 8.4 13.47 8 12.96 8ZM3 1H3.5L5 8H3V1ZM13 9.39C13 10.52 12.3 13.25 11.75 14.01L3 14.47V9H13V9.39Z" }) })));
Aquaclean.iconName = "aquaclean";
Aquaclean.iconCategory = "Product";
export default Aquaclean;
